import React, { useEffect } from 'react';
import { useImageLoadRef } from '@noths/polaris-client-react-hooks';
import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';

import { CSSVarHeight, CSSVarInvertedRation, Image, Picture } from './PictureWithLoad.style';

export interface Props {
  mobileImage: string;
  desktopImage: string;
  setLoadedImages: (src: string) => void;
  alt?: string;
  heightMobile?: string;
  heightDesktop?: string;
  invertRatioMobile?: string;
  invertRatioDesktop?: string;
}

export const PictureWithLoad = ({
  mobileImage,
  desktopImage,
  alt = '',
  heightMobile,
  heightDesktop,
  invertRatioMobile,
  invertRatioDesktop,
  setLoadedImages,
}: Props) => {
  const [imgRef, loaded] = useImageLoadRef();

  useEffect(() => {
    if (loaded && imgRef.current) {
      setLoadedImages(imgRef.current.src);
    }
  }, [setLoadedImages, loaded, imgRef]);

  return (
    // For images that are responsive pass the invertedRatio for desktop and mobile
    // invertedRatio = H/W * 100 (H - height of the image, W - width of the image)
    <picture
      css={Picture}
      data-testid="picture-with-load__picture"
      style={
        {
          '--invertRatioMobile': invertRatioMobile,
          '--invertRatioDesktop': invertRatioDesktop,
        } as CSSVarInvertedRation
      }
    >
      <source media={`(min-width: ${minBreakpoints.M}px)`} srcSet={desktopImage} />
      <img
        data-testid="picture-with-load__img"
        css={Image}
        ref={imgRef}
        src={mobileImage}
        alt={alt}
        // For images that have a fixed height pass the image height for desktop and mobile
        style={
          {
            '--heightMobile': heightMobile,
            '--heightDesktop': heightDesktop,
          } as CSSVarHeight
        }
      />
    </picture>
  );
};
